  <div class="container">
    <div class="row justify-content-center mt-5">
      <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
        <div class="card shadow">
          <div class="card-title text-center border-bottom">
            <h2 class="p-3">Admin Login</h2>
          </div>
          <div class="card-body" [ngClass]="{'cspinner load1': this.showLoader}">
            <form class="info_form p-0 m-0" (ngSubmit)="login()" [formGroup]="loginForm" #loginNgForm="ngForm">

              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input type="text" id="email" class="form-control" placeholder="Enter email" formControlName="email" />
                <ng-container *ngIf="loginForm.controls['email'].dirty || loginForm.controls['email'].touched || loginNgForm.submitted">
                    <div class="text-danger" *ngIf="loginForm?.get('email')?.hasError('required')">
                        This field is required
                    </div>
                    <div class="text-danger" *ngIf="loginForm?.get('email')?.hasError('email') || loginForm?.get('email')?.hasError('pattern')">
                        Please enter valid email
                    </div>
                </ng-container>
              </div>

              <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <div class="input-group">
                  <input type="{{this.hidePassword ? 'password' : 'text'}}" id="password" class="form-control" placeholder="Enter password" formControlName="password">
                  <div class="input-group-append">
                    <span class="input-group-text cp" style="padding: 0.685rem 0.75rem; cursor: pointer;" (click)="this.hidePassword = !this.hidePassword">
                      <i class="fa fa-{{this.hidePassword ? 'eye-slash' : 'eye'}}"></i>
                    </span>
                  </div>
                </div>
                <ng-container *ngIf="loginForm.controls['password'].dirty || loginForm.controls['password'].touched || loginNgForm.submitted">
                    <div class="text-danger" *ngIf="loginForm?.get('password')?.hasError('required')">
                        This field is required
                    </div>
                </ng-container>
              </div>

              <div class="form-row">
                <div class="form-group col-sm-6">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="rememberMe" formControlName="rememberMe">
                    <label class="form-check-label" for="rememberMe">
                      Remember Me
                    </label>
                  </div>
                </div>
                <div class="form-group col-sm-6 text-right">
                  <div class="mb-3">
                    <a routerLink="/forgot-password">Forgot Password?</a>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <button type="submit" class="btn btn-theme btn-block">Login</button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>